import React from 'react';
import Row from '../connectedForm/Row';
import Fieldset from '../connectedForm/Fieldset';

export const OmniMenuList = (props) => {
  const { children, className, cx, getStyles, isMulti } = props;
  //Wrap Each Group.
  const wrappedChildren = Array.isArray(children) ? (
    <Row style={{ width: '97%' }}>
      {children.map((group) => {
        return (
          <Fieldset key={group.key} cols={1 / 4}>
            {group}
          </Fieldset>
        );
      })}
    </Row>
  ) : (
    children
  );

  return (
    <div
      css={getStyles('menuList', props)}
      className={cx(
        {
          'menu-list': true,
          'menu-list--is-multi': isMulti,
        },
        className
      )}
    >
      {wrappedChildren}
    </div>
  );
};

export default OmniMenuList;
